import React from "react";
import { TspCard, TspProgressBar, TspDonutChart, TspEmptyState } from "../../../components/primitives";
import { DISTRIBUTION_METHOD_LABEL, DISTRIBUTION_METHOD_COLOR } from "../../../constants/tspOperations";
import { colorForIndex } from "../../../utils/tspColors";

// `summary` is GET /api/tsp/stats#distribution_summary, or null when the
// caller lacks tsp.book_distribution.view.
// `subject`: what the figures cover, for the empty text ("this journey" / "your temple's journeys").
export default function DistributionSummarySection({ summary, subject = "this journey" }) {
  if (!summary) {
    return (
      <TspCard title="Distribution Summary" className="tsp-title-18">
        <TspEmptyState message="You do not have permission to view book distribution." />
      </TspCard>
    );
  }

  const byBookType = summary.by_book.map((book, index) => ({ ...book, color: colorForIndex(index) }));
  const byMethod = summary.by_method.map((row) => ({
    name: DISTRIBUTION_METHOD_LABEL[row.method] || row.method,
    value: row.quantity,
    percent: summary.total_books > 0 ? `${Math.round((row.quantity / summary.total_books) * 100)}%` : "0%",
    color: DISTRIBUTION_METHOD_COLOR[row.method] || "#9AA3B2",
  }));
  const maxValue = Math.max(1, ...byBookType.map((book) => book.quantity));

  return (
    <TspCard
      title="Distribution Summary"
      className="tsp-title-18"
      action={<span className="tsp-status-pill tsp-status-pill-danger">{summary.total_books.toLocaleString("en-IN")} Total Books</span>}
    >
      {summary.total_books === 0 ? (
        <TspEmptyState message={`No books distributed on ${subject} yet.`} />
      ) : (
        <div className="tsp-stats-two-col">
          <div>
            <h4 className="tsp-subheading">By Book Type</h4>
            <div className="tsp-stats-panel tsp-bars-books">
              {byBookType.map((book) => (
                <TspProgressBar key={book.name} label={book.name} value={book.quantity.toLocaleString("en-IN")} percent={(book.quantity / maxValue) * 100} color={book.color} />
              ))}
            </div>
          </div>
          <div>
            <h4 className="tsp-subheading">By Method</h4>
            <div className="tsp-stats-panel">
              <TspDonutChart data={byMethod} centerLabel="Total Books" centerValue={summary.total_books} height={150} />
            </div>
          </div>
        </div>
      )}
    </TspCard>
  );
}
